import { List } from 'immutable';
import {
  confirmLexicalStateInCTAComponent,
  confirmLexicalStateInTextComponent,
} from 'modules/draftjs2lexical';
import * as lexicalHelpers from 'modules/Lexical/helpers';
import { DocumentsKey, Layer } from 'const';
import * as Models from 'models';
import { isCallToAction, isImage, isTextComponent } from 'utils/entityType';

export function getAbbreviationIdsFromRelationOrDocument(
  relation: Models.LayeredRelationMap,
  documents: Models.AppState.DocumentsMap,
  activeLayer: Layer,
  projectType: string,
): string[] {
  if (isImage(relation)) {
    return relation.getIn(['styles', activeLayer, 'abbreviations'], []); // ['912314','214124']
  }

  if (isTextComponent(relation)) {
    const textComponent: Models.TextComponentMap | undefined = documents.get(DocumentsKey.TEXT_COMPONENTS)
      .get(relation.getIn(['documentId', activeLayer]));
    if (!textComponent) {
      return [];
    }
    const styles = relation?.get('styles')?.get(activeLayer)?.toJS() as Models.TextRelationStyles;

    return lexicalHelpers.getAbbreviationIdsFromDocument(
      confirmLexicalStateInTextComponent(textComponent, styles ?? null),
    );
  }

  if (isCallToAction(relation)) {
    const callToAction: Models.CallToActionMap | undefined = documents.get(DocumentsKey.CALL_TO_ACTIONS)
      .get(relation.getIn(['documentId', activeLayer]));
    if (!callToAction) {
      return [];
    }
    const styles = relation?.get('styles')?.get(activeLayer)?.toJS() as Models.CallToActionStyles;

    return lexicalHelpers.getAbbreviationIdsFromDocument(
      confirmLexicalStateInCTAComponent(
        callToAction,
        styles,
        projectType,
      ),
    );
  }

  return [];
}

export function getAbbreviationIdsFromRelationsAndDocuments(
  relations: List<Models.LayeredRelationMap>,
  documents: Models.AppState.DocumentsMap,
  projectType: string,
  activeLayer: Layer = Layer.ORIGINAL,
): string[] {
  const abbreviationsIds: string[] = [];

  for (const relation of relations) {
    abbreviationsIds.push(
      ...getAbbreviationIdsFromRelationOrDocument(relation, documents, activeLayer, projectType),
    );
  }

  return abbreviationsIds;
}
